import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@material-ui/core";
import CountrySelect from "../../CountrySelect/CountrySelect";
import {connect} from "react-redux";
import actions from "../../../actions";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Done} from "@material-ui/icons";

const styles = {
    formComponent: {
        marginLeft: 5,
        marginRight: 5
    }
};

class EditEntryPanel extends Component {

    handleCancel = () => {
        this.props.handleCancel();
        this.props.resetEdit();
    };

    handleChange = (event, playerIdx, fieldName) => {
        // just make a copy
        const players = this.props.players.map(p => p);
        const p = {...players[playerIdx]};
        p[fieldName] = event.target.value;
        players[playerIdx] = p;
        this.props.editPlayers(players);
    };

    handleCountryUpdate = (country, playerIdx) => {
        // make a copy of the players array
        const players = this.props.players.map(p => p);
        const p = {...players[playerIdx]};
        if (p.country === country) {
            return;
        }
        p.country = country;
        players[playerIdx] = p;
        this.props.editPlayers(players);
    };

    handleSave = () => {
        const entry = {...this.props.entry};
        entry.players = this.props.players;
        this.props.updateEntry(entry);
    };

    handleClose = () => {
        this.props.handleCancel();
        this.props.resetEdit();
    };

    entryDirty = () => {
        let dirty = false;
        this.props.players.forEach((p, idx) => {
            const p2 = this.props.entry.players[idx];
            if (p2.lastName !== p.lastName || p2.firstName !== p.firstName || p2.country !== p.country) {
                dirty = true;
            }
        });
        return dirty;
    };

    render()  {
        const {classes, players} = this.props;
        const cells = [];
        players.forEach((p, idx) => {
            const playerNum = idx + 1;
            const lastNameId = "playerLastName" + idx;
            const firstNameId = "playerFirstName" + idx;
            cells.push(<DialogContentText variant="subtitle2" key={"player" + idx}>{"Player #" + playerNum}</DialogContentText>);
            cells.push(<TextField variant="outlined" fullWidth key={lastNameId} margin="dense" id={lastNameId} value={p.lastName} label="Last Name" onChange={(e) => this.handleChange(e, idx, 'lastName')} /> )
            cells.push(<TextField variant="outlined" fullWidth className={classes.formControl} key={firstNameId} margin="dense" id={firstNameId} value={p.firstName} label="First Name" onChange={(e) => this.handleChange(e, idx, 'firstName')} /> )
            cells.push(<CountrySelect key={"playerCountry" + idx} className={classes.formControl} onCountrySelected={(country) => this.handleCountryUpdate(country, idx)} country={p.country} />);
        });

        let saveButton;
        let cancelButton = <Button onClick={() => this.handleCancel()} color="secondary">Cancel</Button>;

        let successText = null;
        if (this.props.updateStatus === actions.UPDATE_REGISTRATION_ENTRY_SUCCESS) {
            saveButton = <Button onClick={() => this.handleClose()} color="primary">Close</Button>;
            successText = <DialogContentText color="primary"><Done />Entry saved!</DialogContentText>;
            cancelButton = null;
        } else {
            if (this.entryDirty()) {
                saveButton = <Button onClick={() => this.handleSave()} color="primary">Save</Button>;
            } else {
                saveButton = <Button onClick={() => this.handleClose()} color="primary">Close</Button>;
            }
        }

        const progress = this.props.updateStatus === actions.UPDATE_REGISTRATION_ENTRY_STARTED ?
            <LinearProgress /> : null;

        const error = this.props.updateError ? <DialogContentText color="error">Error saving registration entry!</DialogContentText> : null;

        return (
            <Dialog open>
                <DialogTitle id="form-dialog-title">Edit Entry</DialogTitle>
                {progress}
                <DialogContent>
                    {error}
                    {successText}
                    {cells}
                </DialogContent>
                <DialogActions>
                    {saveButton}
                    {cancelButton}
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        updateStatus: state.root.regEntryUpdateStatus,
        updateError: state.root.regEntryUpdateError,
        entry: state.root.regEntryEdit,
        players: state.root.regEntryEditPlayers
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetEdit: () => dispatch({type: actions.UPDATE_REGISTRATION_ENTRY_RESET}),
        updateEntry: (entry) => dispatch({type: actions.UPDATE_REGISTRATION_ENTRY, regEntry: entry}),
        editPlayers: (players) => dispatch({type: actions.EDIT_REGISTRATION_ENTRY_PLAYERS, players: players})
    };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(EditEntryPanel));